<template>
  <v-navigation-drawer
    app right touchless
    disable-resize-watcher
    :floating="temporary"
    :temporary="temporary"
    :width="isMobile ? '100vw' : 450"
    :value="appMessage"
    @input="value => toggleDrawer({ target: 'appMessage', value })"
  >
    <v-toolbar flat class="secondary">
      <v-toolbar-title class="primary--text">我的消息</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        v-if="$vuetify.breakpoint.lgAndUp"
        dark icon
        :title="temporary ? '固定' : '不固定'"
        @click="temporary = !temporary"
      >
        <v-icon v-if="temporary">mdi-pin</v-icon>
        <v-icon v-if="!temporary">mdi-pin-off</v-icon>
      </v-btn>
      <v-btn v-if="isMobile" dark icon @click="toggleDrawer({ target: 'appMessage', value: false })">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <div :style="height">
      <vue-scroll v-if="messages.length > 0">
        <v-list three-line>
          <v-slide-x-reverse-transition group>
            <v-list-item
              v-for="message in messages"
              :key="message.id"
              :to="message.path"
            >
              <v-list-item-content>
                <v-list-item-subtitle class="subtitle-2 secondary--text" v-text="message.content"></v-list-item-subtitle>
                <v-list-item-subtitle class="mt-1" v-text="message.created_from_now"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-icon>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-slide-x-reverse-transition>
        </v-list>
      </vue-scroll>
      <div v-else class="d-flex align-center" style="width: 100%; height: 100%">
        <div class="col-12 text-center">
          <div class="title">没有任何消息</div>
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
  import { mapState } from 'vuex'
  import drawer from '../../../../mixins/drawer'
  import store from "../../../../plugins/vuex";

  export default {
    name: 'app-message',
    mixins: [drawer],
    data: () => ({
      loading: false,
      interval: true,
      temporary: true,

      messages: []
    }),
    computed: {
      ...mapState({
        appMessage: state => state.appMessage
      }),
      height () {
        return {
          height: `calc(100% - ${this.$vuetify.breakpoint.mdAndUp ? '64px' : '56px'})`
        }
      }
    },
    methods: {
      onMessage (message) {
        const id = _.uniqueId()
        this.messages.unshift(message)
        this.$store.commit('pushSnackbar', {
          id: id,
          type: 'success',
          message: _.get(message, 'content'),
          timeout: setTimeout(() => {
            store.commit('removeSnackbar', id)
          }, 2000)
        })
        this.updateCount()
      },
      updateCount () {
        this.$store.commit('assignValue', {
          messages: this.messages.length
        })
      },

      refreshTime () {
        this.messages.map(message => Object.assign({}, message, {
          created_from_now: $moment(_.get(message, 'created_at')).fromNow()
        }))
      },
    },
    created () {
      this.interval = setInterval(this.refreshTime, 5000)
    },
    mounted () {
      this.$bus.$on('message', this.onMessage)
    },
    beforeDestroy () {
      clearInterval(this.interval)
    }
  }
</script>
